export default __webpack_public_path__ + "fonts/inter-latin-500-normal.9d13296f7b5b07a33c7c.woff";